<!--
Standard COVID/health warning text at the head of a confirmation, etc. screen

[19/10/2021] Moved to the foot of the booking confirmation screen now. :-P
Usage: <CovidHeader />
@author cm359n
-->
<template>
  <div class="content">
      <div class="alert alert-danger" id="covidGuidance" role="alert">
          <table class="guidanceTbl">
            <tr>
              <td class="guidanceHeading"><img alt="important" src="@/assets/error_white.svg" style="margin-top:-4px;margin-right:5px;margin-left:-5px;" /> COVID-19 Guidance</td>
            </tr>
            <tr>
              <td class="guidanceContent">
                <p>
                Please ensure you follow all on campus
                guidelines for your safety and for others.
                </p>
                <button v-on:click="go('https://www.gla.ac.uk/myglasgow/news/coronavirus/')" class="findOutMore">Find out more</button>
              </td>
            </tr>
          </table>
        </div>
  </div>
</template>

<script>

export default {
  name: 'CovidHeader',
  props: ['extraText'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    go (url) {
      window.open(url)
    }
  }
}
</script>

<style>
#covidGuidance {
  /* margin-left:16px;
  margin-right:16px; */
  margin-top:24px;
  background-color:#5B4D94;
  color:white;
  min-height: 133px;
  border-radius: 24px;
  border-color: #5B4D94;
}
.guidanceHeading {
  font-size: 18px;
  font-weight: 700;
}
.guidanceContent {
  font-weight: 400;
  font-size: 18px;
}
.guidanceContent p {
  font-size: 18px;
  margin-top: 12px;
}
.guidanceTbl {
  width: 100%;
}
.findOutMore {
  color:#003865;
  font-weight:bold;
  width: 100%;
  height: 52px;
  border-radius: 12px;
  border-color: #ffffff;
  background-color: #ffffff;
  border-style: solid;
  margin-bottom: 10px;
}
.covidActionIcon {
  float:right;
  margin-right:12px;
  margin-bottom:1px;
}
.covidRuleIcon {
  margin-left:12px;
  margin-right:8px;
  margin-bottom:1px;
}
.covidGuidelines {
  margin-left:12px;
  margin-right:12px;
  margin-top:32px;
  padding-bottom:24px;
  border:1px solid #00B5D1;
  border-radius:6px;
}

</style>
